import { type EditCustomPageProps } from '../../features';
import { Wrapper } from './CustomPage.styled';

export const EditCustomPage = (props: EditCustomPageProps) => {
  const { pageId } = props;

  return <Wrapper data-testid="edit-page-view">{`Edit page ID: ${pageId}`}</Wrapper>;
};
